import CheckupApi from '../api/checkup';
import CheckupCatalog from '../models/checkup/catalog';
import CheckupItem from '../models/checkup/item';
import CheckupPrescription from '../models/checkup/prescription';
import CheckupAnswer from '../models/checkup/answer';

const env = process.env;
const checkupApi = new CheckupApi(
  env.VUE_APP_API_CHECKUP_URL,
  env.VUE_APP_API_CHECKUP_TIMEOUT
);

const state = {
  catalogs: [],
  items: [],
  prescriptions: {},
  answers: {},
};

const getters = {
  checkupPrescriptions: state => clientId => {
    if (!state.prescriptions[clientId]) {
      return [];
    }

    return state.prescriptions[clientId];
  },

  checkupAnswers: state => clientId => {
    if (!state.answers[clientId] || state.answers[clientId].length === 0) {
      return [];
    }

    return state.answers[clientId];
  },
};

const mutations = {
  CHECKUP_SET_CATALOGS: (state, payload) => {
    const catalogs = [];

    for (const item of payload) {
      catalogs.push(new CheckupCatalog(item));
    }

    state.catalogs = catalogs;
  },

  CHECKUP_SET_ITEMS: (state, payload) => {
    const items = [];

    for (const item of payload) {
      items.push(new CheckupItem(item));
    }

    state.items = items;
  },

  CHECKUP_SET_PRESCRIPTIONS: (state, payload) => {
    const prescriptions = [];

    for (const item of payload.items) {
      prescriptions.push(new CheckupPrescription(item));
    }

    state.prescriptions[payload.clientId] = prescriptions;
    state.prescriptions = Object.assign({}, state.prescriptions);
  },

  CHECKUP_SET_ANSWERS: (state, payload) => {
    const answers = [];

    for (const item of payload.items) {
      answers.push(new CheckupAnswer(item));
    }

    state.answers[payload.clientId] = answers;
    state.answers = Object.assign({}, state.answers);
  },
};

const actions = {
  CHECKUP_LOAD_CATALOGS: async (context) => {
    const data = await checkupApi.getCatalogs(context.rootState.token);

    context.commit('CHECKUP_SET_CATALOGS', data.items);
  },

  CHECKUP_LOAD_ITEMS: async (context) => {
    const data = await checkupApi.getItems(context.rootState.token);

    context.commit('CHECKUP_SET_ITEMS', data.items);
  },

  CHECKUP_LOAD_PRESCRIPTIONS: async (context, payload) => {
    const token = context.rootState.token;
    const result = await checkupApi.getPrescriptions(token, payload);
    const data = {items: result.items, clientId: payload};

    context.commit('CHECKUP_SET_PRESCRIPTIONS', data, payload);
  },

  CHECKUP_LOAD_ANSWERS: async (context, payload) => {
    const token = context.rootState.token;
    const result = await checkupApi.getAnswers(token, payload);
    const data = {items: result.items, clientId: payload};

    context.commit('CHECKUP_SET_ANSWERS', data);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
